module.exports = __webpack_public_path__ + "img/2-21.7fd83d0c.jpg";